var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnstackMarkInverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "22px",
    viewBox: "0 0 26 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "45.2233426%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96A2EF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7FE2",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-485.000000, -7589.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unstack-mark-inverse",
    transform: "translate(485.000000, 7589.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.322,11.3717143 L25.2487083,12.298381 C26.122135,12.7182857 26.1752617,13.5161905 25.366835,14.0714286 L14.4399017,21.5761905 C14.0356883,21.8538095 13.5028617,21.9925714 12.970035,21.9925714 C12.4372083,21.9925714 11.9043817,21.8538095 11.5001683,21.5761905 L0.573235008,14.0714286 C-0.235191659,13.5161905 -0.181978325,12.7182857 0.691361675,12.298381 L2.617,11.3717143 L10.9591083,15.6691429 C11.5118683,15.9539048 12.2260883,16.1106667 12.970035,16.1106667 C13.7139817,16.1106667 14.4282017,15.9539048 14.9809617,15.6691429 L23.322,11.3717143 Z M20.715,10.1179524 L22.055,10.7627143 L14.5395683,14.6342857 C14.1079683,14.8565714 13.5390883,14.9677143 12.9701217,14.9677143 C12.4012417,14.9677143 11.832275,14.8565714 11.400675,14.6342857 L3.884,10.7627143 L4.855,10.2949524 L4.85569501,10.7761905 L20.715695,10.7761905 L20.715,10.1179524 Z",
    id: "Combined-Shape",
    fill: "#313983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1179545,6.35566667 L25.2137817,7.63114286 C26.1064483,7.99895238 26.1305417,8.66371429 25.267255,9.10838095 L14.5395683,14.6342857 C14.1079683,14.8565714 13.5390883,14.9677143 12.9701217,14.9677143 C12.4012417,14.9677143 11.832275,14.8565714 11.400675,14.6342857 L0.672988341,9.10838095 C-0.190211659,8.66371429 -0.166204992,7.99895238 0.726461675,7.63114286 L3.82095451,6.35566667 L11.005475,8.82266667 C11.5433283,9.00733333 12.240995,9.10904762 12.970035,9.10904762 C13.6991617,9.10904762 14.3968283,9.00733333 14.934595,8.82266667 L22.1179545,6.35566667 Z M12.970035,2.97866667 C13.558415,2.97866667 14.1467083,3.07057143 14.5930417,3.25447619 L20.5339545,5.70166667 L14.624415,7.73190476 C14.169415,7.88809524 13.5697683,7.96619048 12.970035,7.96619048 C12.3703017,7.96619048 11.7705683,7.88809524 11.315655,7.73190476 L5.40595451,5.70166667 L11.3472017,3.25447619 C11.7934483,3.07057143 12.3817417,2.97866667 12.970035,2.97866667 Z",
    id: "Combined-Shape",
    fill: "#505CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.970035,2.56683563e-13 C13.5796483,2.56683563e-13 14.189175,0.0635238095 14.6516283,0.190571429 L25.1551083,3.07619048 C26.0799283,3.33028571 26.092235,3.79380952 25.182235,4.10628571 L14.624415,7.73190476 C14.169415,7.88809524 13.5697683,7.96619048 12.970035,7.96619048 C12.3703017,7.96619048 11.7705683,7.88809524 11.315655,7.73190476 L0.757835008,4.10628571 C-0.152078325,3.79380952 -0.139858325,3.33028571 0.784961675,3.07619048 L11.2884417,0.190571429 C11.750895,0.0635238095 12.3605083,2.56683563e-13 12.970035,2.56683563e-13 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstackMarkInverse);
export default __webpack_public_path__ + "static/media/unstack-mark-inverse.7ca58fd1446c246b944ed4205b075739.svg";
export { ForwardRef as ReactComponent };